// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".correct {\n    fill: #39FF14;\n}\n.incorrect {\n    fill: red;\n}", "",{"version":3,"sources":["webpack://src/components/games/FindUnisonNotes.css"],"names":[],"mappings":"AAAA;IACI,aAAa;AACjB;AACA;IACI,SAAS;AACb","sourcesContent":[".correct {\n    fill: #39FF14;\n}\n.incorrect {\n    fill: red;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
